<template>
  <div class="aside">
    <div class="head">
      <div class="aratar">
        <img
          class="avatarImg"
          :src="
            peopleMessage.avatar
              | imageUrl('/static/profile_img_default.png', 180, 180)
          "
        />
        <img
          class="vImg"
          v-if="peopleMessage.userType == 2 && peopleMessage.isCertification === 1"
          src="/static/v2/match/Verified_icon_blue_20.png"
          alt=""
        />
      </div>
      <p class="name">{{ peopleMessage.nickname }}</p>
      <p class="intro">
        {{
          language === "zh"
            ? peopleMessage.introduce
            : peopleMessage.enIntroduce
        }}
      </p>
      <div class="areaName">
        <img class="iconImg" src="/static/v2/location_icon.png" alt="" />{{
          peopleMessage.areaName
        }}
      </div>
      <div class="countBox">
        <span @click="gotoPeople(1)"
          >{{ $t("global.关注") }}<i>{{ followCount || 0 }}</i></span
        >
        <span @click="gotoPeople(2)"
          >{{ $t("global.粉丝") }}<i>{{ fansCount || 0 }}</i></span
        >
      </div>
      <span @click="gotoPeople(null)" class="myHome">{{
        $t("people.我的个人主页")
      }}</span>
    </div>
    <div class="navList">
      <router-link
        to="/manageVideo"
        :class="{ active: currentUrl == '/manageVideo' }"
        >{{ $t("people.视频管理") }}</router-link
      >
      <router-link
        to="/MyCollect"
        :class="{ active: currentUrl == '/MyCollect' }"
        >{{ $t("global.我的收藏") }}</router-link
      >
      <router-link
        to="/playRecord"
        :class="{ active: currentUrl == '/playRecord' }"
        >{{ $t("people.历史记录") }}</router-link
      >
    </div>
    <div class="navList">
      <router-link
        to="/my/order"
        :class="{ active: currentUrl == '/my/order' }"
        >{{ $t("live.我的订单") }}</router-link
      >
      <router-link
        to="/my/article"
        :class="{ active: currentUrl == '/my/article' }"
        >{{ $t("global.我的文章") }}</router-link
      >
      <router-link
        to="/MySpecialSubject"
        :class="{ active: currentUrl == '/MySpecialSubject' }"
        >{{ $t("global.我的频道") }}</router-link
      >
      <router-link
        to="/MyActivity"
        :class="{ active: currentUrl == '/MyActivity' }"
        >{{ $t("global.我的活动") }}</router-link
      >
      <router-link
        to="/MyCompetition"
        :class="{ active: currentUrl == '/MyCompetition' }"
        >{{ $t("global.我的竞赛") }}</router-link
      >
      <div class="accoutSet" v-if="isAuthentication">
        <router-link
          to="/MyRecruit"
          :class="{ active: currentUrl == '/MyRecruit' || currentUrl == '/Resume' }"
          >{{ $t("recruit.招聘/求职") }}</router-link
        >
        <div class="navBox">
          <span :class="{ active1: currentUrl == '/MyRecruit' }" @click="gotoRecruit(null)">{{ $t("recruit.职位管理") }}</span>
          <span :class="{ active1: currentUrl == '/Resume' }" @click="gotoRecruit(1)">{{ $t("recruit.收到的简历") }}<i class="tips1" v-if="resumeNumber">{{resumeNumber}}个新简历</i></span>
        </div>
      </div>
      <div class="accoutSet" v-else>
        <router-link
          to="/jobWanted"
          :class="{ active: currentUrl == '/jobWanted' || currentUrl == '/MyResume' }"
          >{{ $t("recruit.招聘/求职") }}</router-link
        >
        <div class="navBox">
          <span :class="{ active1: currentUrl == '/jobWanted' }" @click="gotoRecruit1(1)">{{ $t("recruit.求职管理") }}</span>
          <span :class="{ active1: currentUrl == '/MyResume' }" @click="gotoRecruit1(2)">{{ $t("recruit.我的简历") }}<i class="tips2" v-if="isOk">待完善</i></span>
          <span @click="gotoRecruit1(null)">{{ $t("recruit.我要招人") }}</span>
        </div>
      </div>
    </div>
    <div class="navList">
      <router-link
        to="/ApplyIdentification"
        :class="{ active: currentUrl == '/ApplyIdentification' }"
        >{{ $t("people.认证管理") }}</router-link
      >

      <div class="accoutSet">
        <router-link
          to="/manageCenter"
          :class="{ active: currentUrl == '/manageCenter' }"
          >{{ $t("people.账户设置") }}</router-link
        >
        <div class="navBox">
          <span :class="{ active1: step == null && currentUrl == '/manageCenter' }" @click="gotoManage(null)">{{
            $t("global.个人资料")
          }}</span>
          <span :class="{ active1: step == 1 }" @click="gotoManage(1)">{{
            $t("people.账号与安全")
          }}</span>
          <el-popover placement="right" trigger="hover">
            <div class="popoverDiv">
              <div
                :class="{ zhDiv: peopleMessage.userLanguage == '0' }"
                @click="changeLanguage('0')"
              >
                <img
                  v-if="peopleMessage.userLanguage == '0'"
                  src="/static/peopleCenter/lang_tick@2x.png"
                  alt=""
                />简体中文
              </div>
              <div
                :class="{ enDiv: peopleMessage.userLanguage == '1' }"
                @click="changeLanguage('1')"
              >
                <img
                  v-if="peopleMessage.userLanguage == '1'"
                  src="/static/peopleCenter/lang_tick@2x.png"
                  alt=""
                />English
              </div>
            </div>
            <div class="langBox" slot="reference">
              {{ $t("people.语言") }}：{{
                peopleMessage.userLanguage == '0' ? "简体中文" : "English"
              }}
              >
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <p class="loginout" @click="changeIndex">{{ $t("global.退出登录") }}</p>
    <div class="popBox" v-if="isShowPop">
        <div class="box">
          <div class="title">
            {{$t("recruit.企业认证")}}
            <span @click="isShowPop=false"></span>
          </div>
          <div class="info">{{popInfo}}</div>
          <div class="but">
            <span @click="but">{{popBut}}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "asideCom",
  props: ["resumeNumber"],
  data() {
    return {
      currentUrl: this.$route.path,
      followCount: null,
      fansCount: null,
      step: null,
      isAuthentication: true,
      isOk: true,
      popInfo: "",
      popBut: "",
      isShowPop: false,
      popType: 1
    };
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    }
  },
  mounted() {
    this.getInfo();
  },
  watch: {
    $route(val) {
      if (val.path.indexOf("/manageCenter") !== -1) {
        if (this.$route.query.step && this.$route.query.step == 1) {
          this.step = 1;
        } else {
          this.step = null;
        }
      }
    }
  },
  methods: {
    getInfo() {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then((response) => {
          if (response.code !== "ServiceError") {
            if (
              response.data.userType === 2 &&
              response.data.isCertification === 1
            ) {
              var path = this.$route.path;
              if (path == "/jobWanted") {
                this.$router.push("/MyRecruit");
              }
              this.isAuthentication = true;
              this.getUnread();
            } else {
              var path = this.$route.path;
              if (path == "/MyRecruit") {
                this.$router.push("/jobWanted");
              }
              if (path == "/Resume") {
                this.$router.push("/jobWanted");
              }
              this.isAuthentication = false;
              this.getResumeCheck();
            }
            this.$http
              .get(
                "/api/mobile/u/getInfo?userId=" +
                  response.data.userId +
                  "&type=1"
              )
              .then((res) => {
                if (res.code === "OK") {
                  this.followCount = res.data.followCount;
                  this.fansCount = res.data.fansCount;
                }
              });
          } else {
            this.loginout();
          }
        });
      } else {
        this.loginout();
      }
    },
    loginout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      this.$router.push(`/login?redirecturl=${window.location.href}`);
    },
    getUnread() {
      this.$http.get("/api/u/recruit/manage/unread").then((res)=>{
        if (res.code == "OK") {
          this.resumeNumber = res.data;
        }
      })
    },
    getResumeCheck() {
      this.$http
        .get("/api/u/recruit/resume/online/info/resume/check")
        .then(res => {
          if (res.code == "OK") {
            if (res.data.isOk == 1) {
              //简历已完善
              this.isOk = false;
            } else {
              //简历未完善
              this.isOk = true;
            }
          }
        });
    },
    changeLanguage(language) {
      if (language == this.peopleMessage.userLanguage) {
        return;
      }
      this.$http.post("/api/u/changeLanguage").then(res => {
        switch (language) {
          case "0":
            location.hash = "#!zh";
            break;
          case "1":
            location.hash = "#!en";
            break;
        }
        location.reload();
      });
    },
    gotoManage(val) {
      if (val) {
        this.$router.push("/manageCenter?step=" + val);
      } else {
        this.$router.push("/manageCenter");
      }
      this.step = val;
    },
    gotoRecruit(val) {
      if (val) {
        this.$router.push("/Resume");
      } else {
        this.$router.push("/MyRecruit");
      }
    },
    but() {
      if (this.popType == 1) {
        this.isShowPop = false;
        this.$router.push("/ApplyIdentification?type=1");
      }
      if (this.popType == 2) {
        this.isShowPop = false;
      }
    },
    gotoRecruit1(val) {
      if (val == 1) {
        this.$router.push("/jobWanted");
      }
      if (val == 2) {
        this.$router.push("/MyResume");
      }
      if (!val) {
        this.$http.get("/api/u/certification/company/get").then(res => {
          if (res.code == "OK") {
            if (res.data.status == 0) {
              this.popInfo = this.$t(
                "recruit.请先进行企业认证，认证通过后即可发布招聘信息"
              );
              this.popBut = this.$t("recruit.去认证");
              this.popType = 1;
            }
            if (res.data.status == 1) {
              this.popInfo = this.$t(
                "recruit.您的企业认证信息正在审核中，审核通过后即可发布职位信息，请耐心等待"
              );
              this.popBut = this.$t("recruit.确定");
              this.popType = 2;
            }
            if (res.data.status == 3) {
              this.popInfo = this.$t(
                "recruit.您的企业认证信息未通过，请联系客服"
              );
              this.popBut = this.$t("recruit.确定");
              this.popType = 2;
            }
            this.isShowPop = true;
          }
        });
      }
    },
    gotoPeople(type) {
      let routeData = null;
      if (type) {
        routeData = this.$router.resolve({
          path:
            "/peopleCenter/" + this.peopleMessage.userId + "/home?type=" + type
        });
      } else {
        routeData = this.$router.resolve({
          path: "/peopleCenter/" + this.peopleMessage.userId + "/home"
        });
      }
      window.open(routeData.href, "_blank");
    },
    changeIndex() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      this.$router.push("/");
    }
  }
};
</script>
<style>
.el-popover {
  min-width: 84px !important;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.aside {
  width: 255px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  padding-top: 16px;
  margin-right: 30px;
  height: min-content;

  .head {
    padding: 0 20px 20px;
    width: 215px;

    .aratar {
      width: 70px;
      height: 70px;
      margin: 0 auto;
      position: relative;

      .avatarImg {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }

      .vImg {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }

    .name {
      margin: 16px 0 8px 0;
      font-size: 16px;
      font-weight: 600;
      color: #0A0A0A;
      line-height: 22px;
      text-align: center;
    }

    .intro {
      height: 24px;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .areaName {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      margin: 8px 0;

      .iconImg {
        width: 10px;
        height: 13px;
        margin-right: 4px;
        margin-bottom: 2px;
      }
    }

    .countBox {
      margin-bottom: 16px;
      text-align: center;
      line-height: 24px;

      span {
        font-size: 13px;
        font-weight: 400;
        color: #666666;
        margin-left: 2px;
        cursor: pointer;

        i {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          margin-left: 6px;
        }
      }
    }

    .myHome {
      display: block;
      width: 110px;
      height: 28px;
      border: 1px solid #2026CC;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: #2026CC;
      margin: 0 auto;
      cursor: pointer;
    }
  }

  .navList {
    border-top: 1px solid rgba(235, 235, 235, 1);
    padding-top: 18px;

    a {
      margin-bottom: 16px;
      display: block;
      padding-left: 28px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      box-sizing: border-box;

      &:hover {
        color: #2026CC;
      }
    }

    .accoutSet {
      padding-bottom: 20px;

      .navBox {
        span {
          display: block;
          margin-left: 52px;
          margin-top: 12px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 400;
          color: #666666;

          &:hover {
            color: #2026CC;
          }
          i.tips1{
            padding: 0 5px;
            display: inline-block;
            height: 16px;
            line-height: 16px;
            background: #FC6240;
            border-radius: 8px;
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 4px;
          }
          i.tips2{
            padding: 0 5px;
            display: inline-block;
            height: 16px;
            line-height: 16px;
            background: #FE5630;
            border-radius: 3px;
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 4px;
          }
        }

        .langBox {
          display: inline-block;
        }

        .active1 {
          color: #2026CC;
        }
      }
    }

    .active {
      border-left: 4px solid rgba(32, 38, 204, 1);
      padding-left: 24px;
      font-weight: 600;
      color: #2026CC;
    }
  }

  .loginout {
    border-top: 1px solid rgba(235, 235, 235, 1);
    font-size: 14px;
    font-weight: 400;
    color: #FE5630;
    height: 60px;
    line-height: 60px;
    padding-left: 28px;
    cursor: pointer;
  }
  .popBox{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 111;
    .box{
      width: 760px;
      padding-bottom: 50px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      .title {
        text-align: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 25px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      .info {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        margin: 44px 0 54px 0;
        padding: 0 102px;
        text-align: center;
      }
      .but {
        text-align: center;
        span {
          padding: 0 35px;
          height: 40px;
          background: #2026CC;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
}

.popoverDiv {
  div {
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    text-align: center;
    cursor: pointer;

    img {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
  }

  .zhDiv, .enDiv {
    font-weight: 600;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aside.vue